module.exports = __webpack_public_path__ + "img/confidence1.dcaaa278.png";